export function stringEqualsCI(text?: string, other?: string) {
  return text && other && text.localeCompare(other, undefined, { sensitivity: 'base' }) === 0;
}